import { IParamsByUrl } from '~types/search'

const sortSelected = ({
  urlParams,
  value,
}: {
  urlParams: IParamsByUrl
  value?: string | null
}) => {
  const params = {
    ...(urlParams || {}),
    currentPage: 1,
    sort: value || '',
  }

  return params
}

export default sortSelected
